import React from 'react';
import { Table, ButtonGroup, Button } from 'react-bootstrap';
import Row from './components/Row';

const AffidTable = ({ cutoffs, onRemove, onUpdate }) => {
    const rows = cutoffs.map((cutoff, index) => <Row key={index} cutoff={cutoff} onUpdate={onUpdate} onRemove={onRemove}/>);

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
            <tr>
                <th>Affid</th>
                <th>Country</th>
                <th>Base</th>
                <th>Weekend</th>
                <th>Action</th>
            </tr>
            </thead>
            <tbody>
            {rows}
            </tbody>
        </Table>
    )
};

export default AffidTable;


// WEBPACK FOOTER //
// ./src/scenes/PcCutoff/components/Affid/components/Table/index.js